/**
 * Utility functions for images
 */


function change_image_size(image_url, size){

}

/**
 * 
 * @param {string} image_url 
 * @returns {string}
 */
function get_image_mime_type(image_url){

    let parts = image_url.split('/');
    let filename = parts[parts.length - 1];
    parts = filename.split(".");
    let extension = parts[parts.length - 1];

    switch (extension.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
            return "image/jpg";
            break;
        case 'png':
            return "image/png";
            break;
        case 'gif':
            return "image/gif";
            break;
        case 'webp':
            return "image/webp";
            break;
    
        default:
            return '';
    }
}

function get_image_id(image_url){

}

function img_has_webp(image_url){

    
}

export {
    change_image_size,
    get_image_mime_type,
    get_image_id,
    img_has_webp,
};